import RytmWebflow from 'rytm-webflow';
import { trace } from 'rytm-helpers';
import { WCAG } from "rytm-wcag";
import { windowUpdate, removeReCaptchaBadge } from './shared/common';
import { initCarousels, destroyCarousels } from './shared/carousel';
import { closeAllDropdowns } from './ck/header-dropdown';
// controllers
import Controller from './controllers/Controller'
// views
// import View from './views/View'

const routes = {
  'webflow': {
    controller: Controller,
    view: RytmWebflow.WebflowView
  },
  'list': {
    controller: Controller,
    view: RytmWebflow.WebflowListView
  },
}
const aswapProps = {
  animationTimeHide: 800,
  animationTimeShow: 800,
  preloadOnHover: false,
  cacheOn: true,
  refreshOnSameUrl: false,
  routes,
  trace,
}
const aswapEvents = {
  onViewSwapComplete: () => {
    WCAG.onViewChanged();
    windowUpdate();
    initCarousels();
    RytmWebflow.showUp.rebuild();
  },
  onViewHide: () => {
    WCAG.dialogCloseAll();
    removeReCaptchaBadge();
    // RytmWebflow.showUp.hide();
    RytmWebflow.bootsrap5.hideFlyovers();
    // close dropdown menu
    closeAllDropdowns();
  },
  onViewHidden: () => {
    // destroy...
    destroyCarousels();
  },
  onRequestSameUrl: () => {
    // same url request
    RytmWebflow.bootsrap5.hideFlyovers();
  },
}

export const initASwap = () => {
  RytmWebflow.aswap.init(aswapProps, aswapEvents);
}